module.exports = __webpack_public_path__ + "img/houwei.3dff8455.jpg";